import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class View extends PureComponent {
  render() {
    const { parent } = this.props;
    return (
      <table className="responsive">
        <thead>
          <tr>
            <th colSpan="2">保護者情報</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>保護者さま氏名</th>
            <td>
              <span>
                {parent.last_name}
                {' '}
                {parent.first_name}
              </span>
            </td>
          </tr>
          <tr>
            <th>フリガナ</th>
            <td>
              <span>
                {parent.last_name_kana}
                {' '}
                {parent.first_name_kana}
              </span>
            </td>
          </tr>
          <tr>
            <th>メールアドレス</th>
            <td><span>{parent.email}</span></td>
          </tr>
          <tr>
            <th>住所</th>
            <td>
              <span>
                〒
                {parent.post_code}
                {' '}
                {parent.prefecture}
                {' '}
                {parent.address1}
                {' '}
                {parent.address2}
                {' '}
                {parent.address3}
              </span>
            </td>
          </tr>
          <tr>
            <th>電話番号</th>
            <td><span>{parent.phone}</span></td>
          </tr>
          <tr>
            <th>メールマガジンの配信</th>
            <td><span>{parent.send_mail_magazine === 'true' ? '配信を希望する' : '配信を希望しない'}</span></td>
          </tr>
        </tbody>
      </table>
    );
  }
}

View.propTypes = {
  parent: PropTypes.shape({
    last_name: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name_kana: PropTypes.string.isRequired,
    first_name_kana: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    post_code: PropTypes.string.isRequired,
    prefecture: PropTypes.string.isRequired,
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string.isRequired,
    address3: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    send_mail_magazine: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect()(View);
